"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delete_document_element_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const delete_document_element_1 = require("../../../../../api/calls/document/delete_document_element");
exports.delete_document_element_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/delete_document_element_thunk", (data, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, document_1.setIsLoading)(true));
    // Check if this is a temp ID (never saved to backend)
    const isTempId = typeof data._id === "string" && data._id.startsWith("temp_");
    if (isTempId) {
        // Temp IDs only exist in Redux, not backend - just remove from local state
        dispatch((0, document_1.removeSelectedDocumentElements)(data._id));
        dispatch((0, document_1.setSelectedElement)(null));
        dispatch((0, document_1.setIsLoading)(false));
        return { success: true };
    }
    // Real backend ID - call API to delete
    const response = yield (0, delete_document_element_1.delete_document_element)(data);
    dispatch((0, document_1.setIsLoading)(false));
    if (response.success) {
        dispatch((0, document_1.removeSelectedDocumentElements)(data._id));
        dispatch((0, document_1.setSelectedElement)(null));
        return response.content;
    }
    else {
        //  dispatch(removeSelectedDocumentElements(data._id));
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
    return null;
}));
